var that;
import nowTimeMixin from "@/mixins/nowTime.js";
export default {
  mixins: [nowTimeMixin],
  data() {
    return {
      details: {},
      // 地块列表
      plotList: [],
      value: "",
      options: [{
        value: "Option1",
        label: "Option1"
      }, {
        value: "Option2",
        label: "Option2"
      }, {
        value: "Option3",
        label: "Option3"
      }, {
        value: "Option4",
        label: "Option4"
      }, {
        value: "Option5",
        label: "Option5"
      }]
      // itemList: [
      //   {
      //     icon: require("../../assets/空气温度.png"),
      //     name: "空气温度",
      //     value: "-10℃",
      //   },
      //   {
      //     icon: require("../../assets/土壤温度.png"),
      //     name: "土壤温度",
      //     value: "-10℃",
      //   },
      //   {
      //     icon: require("../../assets/空气湿度.png"),
      //     name: "空气湿度",
      //     value: "-10℃",
      //   },
      //   {
      //     icon: require("../../assets/二氧化碳.png"),
      //     name: "二氧化碳",
      //     value: "-10℃",
      //   },
      //   {
      //     icon: require("../../assets/土壤湿度.png"),
      //     name: "土壤湿度",
      //     value: "-10℃",
      //   },
      //   {
      //     icon: require("../../assets/光照强度.png"),
      //     name: "光照强度",
      //     value: "60000lux",
      //   },
      // ],
    };
  },

  computed: {
    token() {
      return this.$store.state.token;
    },
    itemList() {
      return [{
        icon: require("../../assets/空气温度.png"),
        name: "空气温度",
        value: this.getObjValueByProp('airTemperature') + '℃'
      }, {
        icon: require("../../assets/土壤温度.png"),
        name: "土壤温度",
        value: this.details.soilTemperature + '℃'
      }, {
        icon: require("../../assets/空气湿度.png"),
        name: "空气湿度",
        value: this.details.airHumidity + '%'
      }, {
        icon: require("../../assets/二氧化碳.png"),
        name: "二氧化碳",
        value: this.details.co2 + 'ppm'
      }, {
        icon: require("../../assets/土壤湿度.png"),
        name: "土壤湿度",
        value: this.details.soilHumidity + '%'
      }, {
        icon: require("../../assets/光照强度.png"),
        name: "光照强度",
        value: this.details.lightIntensity + 'lux'
      }];
    }
  },
  watch: {
    token(newVal) {
      this.getPlotList();
    }
  },
  created() {
    that = this;
    // this.getPlotList();
  },

  methods: {
    // 获取对象中字段的值
    getObjValueByProp(prop) {
      return this.details[prop];
    },
    // 点击
    async optionClick(e) {
      console.log(JSON.parse(JSON.stringify(e)), "lloo");
      let item = JSON.parse(JSON.stringify(e));
      let params = {
        number: item.greenhouseVoList[0].number
      };
      let {
        data,
        code
      } = await this.$api.getLatestData(params.number);
      if (code == "200") {
        this.details = data;
      }
      console.log(data, "环境监测数据");
    },
    // 获取地块列表
    async getPlotList() {
      let params = {
        isMonitor: "0"
      };
      let {
        code,
        rows
      } = await this.$api.getPlotList(params);
      if (code == "200") {
        window.localStorage.setItem('plotList', JSON.stringify(rows));
        this.plotList = rows;
        this.value = rows[0].id;
        let {
          data,
          code
        } = await this.$api.getLatestData(rows[0].greenhouseVoList[0].number);
        if (code == "200") {
          this.details = data;
        }
      }
      console.log(rows, "地块列表");
    },
    async selectChange(e) {
      console.log(e, "eeee");
    }
  }
};